{
  "ru": {
    "action": {
      "one": "Действие",
      "other": "Действия"
    },
    "activate": "Активировать",
    "activerecord": {
      "attributes": {
        "article": {
          "kind": "Тип",
          "title": "Заголовок"
        },
        "article/topic": {
          "title": "Заголовок"
        },
        "campaign": {
          "description": "Описание",
          "name": "Название",
          "url": "Ссылка"
        },
        "championship": {
          "name": "Название"
        },
        "editor": {
          "email": "Почта",
          "promoter_role_id": "Рулон"
        },
        "enrollment": {
          "due_date": "Оплатить до даты",
          "period": "Переодичность",
          "status": "Статус"
        },
        "evaluation_group": {
          "name": "Название"
        },
        "evaluation_option": {
          "evaluation_group_id": "Группа",
          "name": "Название"
        },
        "event": {
          "end_at": "Дата окончания",
          "name": "Название",
          "start_at": "Дата начала",
          "status": "Статус",
          "total_of_comments": "Комментарии",
          "total_of_votes": "Лайки"
        },
        "grade": {
          "name": "Название"
        },
        "invoice": {
          "customer_email": "E-mail клиента",
          "customer_name": "Клиент",
          "description": "Описание",
          "due_date": "Истекает",
          "paid_at": "Дата оплаты",
          "tax_cents": "Комиссия",
          "total_cents": "Стоимость",
          "total_liquid_cents": "Всего"
        },
        "level": {
          "name": "Имя"
        },
        "model": {
          "default": "По умолчанию",
          "group": "Группа",
          "name": "Название"
        },
        "nota_fiscal": {
          "data_competencia": "Дата конкуренции"
        },
        "payment_account": {
          "bank_account": {
            "kind": "Тип",
            "number": "Номер"
          },
          "boleto_cents": "Boleto",
          "credit_card_cents": "Кредитная карта",
          "credit_card_description": "Имя на карте",
          "credit_card_percent": "Кредитная карта",
          "default": "По умолчанию",
          "name": "Имя",
          "person_type": "Тип лица",
          "pix_percent": "Pix",
          "withdraw_cents": "Вывод"
        },
        "payment_category": {
          "name": "Название"
        },
        "payment_method": {
          "name": "Название",
          "tax_amount_input_cents": "Сумма на входе",
          "tax_amount_output_cents": "Сумма на выходе",
          "tax_percentage_input_cents": "Процент при входе",
          "tax_percentage_output_cents": "Процент на выходе"
        },
        "plan": {
          "highlight": "Наличие",
          "name": "Название"
        },
        "product": {
          "amount": "Сумма",
          "featured": "Основные тезисы",
          "name": "Название",
          "quantity": "Количество",
          "sold": "Продано",
          "visible": "Видимый"
        },
        "product_option_type": {
          "presentation": "Презенитация"
        },
        "rhythm": {
          "name": "Имя",
          "parent_id": "Родительский ритм"
        },
        "role": {
          "description": "Описание",
          "name": "Имя"
        },
        "subscription": {
          "charge_date": "Срок оплаты",
          "due_date": "Срок оплаты",
          "end_date": "Окончание",
          "status": "Статус",
          "trial_days": "Триал"
        },
        "tag": {
          "description": "Описание",
          "name": "Имя"
        },
        "ticket_order_item": {
          "checkin": "Регистрироваться"
        },
        "unit": {
          "name": "Имя"
        },
        "user": {
          "birthdate": "Дата рождения",
          "email": "E-mail",
          "first_class_at": "Пробное занятие",
          "name": "Имя"
        },
        "withdraw": {
          "amount_cents": "Чистая сумма",
          "bank_agency": "Агентство",
          "bank_kind": "Тип",
          "bank_number": "Число",
          "paying_at": "Прогноз",
          "tax_cents": "Комиссия",
          "total_cents": "Валовая сумма"
        }
      },
      "models": {
        "address": {
          "one": "Адрес"
        },
        "article": {
          "other": "Статьи"
        },
        "bank": {
          "one": "Банк"
        },
        "contract": {
          "one": "Контракт"
        },
        "coupon": {
          "one": "Купон"
        },
        "credit": {
          "other": "Кредиты"
        },
        "email": {
          "one": "Электронная почта"
        },
        "enrollment": {
          "one": "Регистрация",
          "other": "Зачисления"
        },
        "examiner": {
          "one": "Эксперт",
          "other": "Эксперты"
        },
        "face": {
          "one": "Лицо"
        },
        "grade": {
          "one": "Группа"
        },
        "graduation": {
          "other": "вручение дипломо"
        },
        "invoice": {
          "one": "Счёт"
        },
        "level": {
          "one": "Уровень"
        },
        "message": {
          "one": "сообщение"
        },
        "nota_fiscal": {
          "one": "Нота Фискаль"
        },
        "notification": {
          "other": "Уведомления"
        },
        "order": {
          "one": "Заказ"
        },
        "payment_method": {
          "one": "Способ оплаты"
        },
        "period": {
          "one": "Период"
        },
        "permission": {
          "other": "Разрешения"
        },
        "phone": {
          "one": "Телефон"
        },
        "plan": {
          "one": "План"
        },
        "profile": {
          "one": "Профиль"
        },
        "prospect": {
          "other": "рассмотрено"
        },
        "rhythm": {
          "other": "Ритмы"
        },
        "role": {
          "one": "Профиль"
        },
        "school_course": {
          "one": "Курс"
        },
        "student": {
          "one": "Ученик"
        },
        "subscription": {
          "one": "Подписка",
          "other": "Подписки"
        },
        "tax": {
          "one": "Таксоны"
        },
        "teacher": {
          "one": "Преподаватель",
          "other": "Преподаватели"
        },
        "ticket": {
          "one": "Билет",
          "other": "Билеты"
        },
        "unit": {
          "one": "Филиал",
          "other": "Филиалы"
        },
        "user": {
          "one": "Пользователь"
        },
        "user_note": {
          "other": "Anotações"
        }
      }
    },
    "add_one_more": {
      "charge_card": "Оплата картой",
      "invoice": "Добавить +1 фактуру"
    },
    "allowed": "Разрешено",
    "amount": "Значение",
    "approved": {
      "other": "Сдали"
    },
    "artistic_name": "Художественное имя",
    "blocked": "Заблокировано",
    "cancel": "Отмена",
    "cancel_at": "Дата отмены",
    "charge": {
      "verb": "Заряжать"
    },
    "checkin": {
      "back_camera": "Задняя камера",
      "face_too_far": "Приблизьте лицо",
      "front_camera": "Передняя камера",
      "identifying": "Идентификация",
      "no_face": "Лицо не обнаружено",
      "one_face": "Только одно лицо за раз",
      "quota": "Регистрации",
      "scan_error": "Ошибка идентификации. Попробуйте ещё раз.",
      "unlimited": "Без ограничений"
    },
    "checkout": {
      "loading_message": "Счет обрабатывается, пожалуйста, подождите."
    },
    "code": "Код",
    "controller": "Контроллер",
    "copied": "скопировано!",
    "copy_link": "Копировать ссылку",
    "create_searched_user": "Создать искомого пользователя",
    "created_at": {
      "female": "Создано в",
      "male": "Создано в"
    },
    "current_plan": "Текущий план",
    "cycle": {
      "one": "Цикл"
    },
    "dancer": {
      "role": {
        "one": "Роль"
      }
    },
    "dashboard": "панель приборов",
    "date": {
      "one": "Дата"
    },
    "datepicker": {
      "format": "dd/MM/yy",
      "next_month": "Следующий месяц",
      "placeholder": "__/__/__",
      "previous_month": "Предыдущий месяц"
    },
    "default": "По умолчанию",
    "description": {
      "one": "Описание"
    },
    "detail": {
      "other": "Подробности"
    },
    "disapproved": {
      "other": "Не сдали"
    },
    "discount": {
      "one": "Скидка"
    },
    "document": {
      "one": "Документ"
    },
    "due_date": "Истекщий",
    "edit": "редактировать",
    "email": "электронная почта",
    "end": {
      "one": "Конец"
    },
    "enrollment": {
      "charge": {
        "confirm_charge": "Вы действительно хотите произвести взыскание?"
      }
    },
    "evaluate": "Оценивать",
    "exam": {
      "other": "Экзамены"
    },
    "expires_at": "Срок действия",
    "face": {
      "delete": {
        "confirm": "Вы действительно хотите удалить лицо?"
      },
      "switch_camera": "Переключить камеру"
    },
    "fail": {
      "one": "Отказ"
    },
    "finish_and_graduate": "Закончить и получить диплом",
    "follow": {
      "one": "Фолловер",
      "other": "последователи"
    },
    "graduation": {
      "profile": {
        "not_selected": "Профиль не выбран"
      },
      "role": {
        "not_selected": "Роль не выбрана"
      }
    },
    "gridy": {
      "errors": {
        "record_not_found": "Без результатов."
      },
      "page": {
        "button": {
          "back": "< предыдущая страница",
          "next": "следущая страница >",
          "title": "страница"
        }
      },
      "refresh": {
        "title": "Обновить"
      },
      "search": {
        "label": "Текст запроса",
        "placeholder": "Введите ваш поисковый запрос"
      },
      "status": {
        "full": "Страница {from} с {to} | {total} записей",
        "one": "1 запись найдена",
        "other": "{total} записей найденных",
        "zero": ""
      }
    },
    "gross": "валовой",
    "highlight": "В центре внимания",
    "id": "ID",
    "invoice": {
      "charge": {
        "confirm": "Списать эту оплату с привязанной кредитной карты ученика?"
      },
      "statuses": {
        "refunded": "Возвращено"
      },
      "tip": {
        "refunded": "возвращен: %{comment}"
      }
    },
    "kind": {
      "one": "Тип"
    },
    "lead": {
      "one": "Лидер",
      "other": "лидеры"
    },
    "liquid": "Жидкость",
    "menu": {
      "one": "Меню"
    },
    "method": "Метод",
    "mock": {
      "other": "симуляции"
    },
    "months": {
      "short": {
        "abr": "Апр",
        "ago": "Авг",
        "dez": "Дек",
        "fev": "Фев",
        "jan": "Янв",
        "jul": "Июл",
        "jun": "Июн",
        "mai": "Май",
        "mar": "Мар",
        "nov": "Ноя",
        "out": "Окт",
        "set": "Сен"
      }
    },
    "move": {
      "down": "Переместить вниз",
      "up": "Переместить вверх",
      "verb": "Двигаться"
    },
    "name": "Название",
    "no_result": "Нет результатов",
    "not_found": {
      "female": "Не найдена",
      "male": "Не найдено"
    },
    "nota_fiscal": {
      "cancel": {
        "confirm": "Вы уверены, что хотите отменить nota fiscal?",
        "verb": "Отменить Nota Fiscal"
      },
      "create": {
        "confirm": "Вы уверены, что хотите выдать nota fiscal?",
        "short": "Выдать",
        "verb": "Выдать Nota Fiscal"
      },
      "show": {
        "verb": "Посмотреть Nota Fiscal"
      }
    },
    "notify": "регистрировать",
    "pagarme": "Pagar.me",
    "paid_at": "Оплачено",
    "payment_method": {
      "short": "Метод"
    },
    "pending": {
      "other": "Ожидающие"
    },
    "percentage": {
      "one": "Процент"
    },
    "push_notification": {
      "confirm_question": "Для полноценной работы мы попросим у вас разрешение на уведомления.",
      "denied_message": "Уведомления отключены, чтобы включить авторизацию в вашем браузере.",
      "manual_revoking": "Вам необходимо удалить разрешение прямо из браузера.",
      "status": {
        "default": "Включите уведомления о новых функциях.",
        "denied": "Уведомления заблокированы. Чтобы включить, настройте свой браузер.",
        "granted": "Активные уведомления.",
        "unsupported": "Уведомления не поддерживаются на этом устройстве/браузере/версии."
      }
    },
    "rating": {
      "hints": {
        "basic": {
          "five": "Превосходно",
          "four": "Хороший",
          "one": "Ужасный",
          "three": "Обычный",
          "two": "Плохо"
        },
        "evaluation": {
          "four": "Превосходно",
          "one": "причина отказа",
          "three": "Хороший",
          "two": "Тренировать"
        }
      },
      "no_rated_msg": "Пока нет отзывов."
    },
    "recurrence": {
      "one": "Рецидив"
    },
    "refund": {
      "verb": "Рембольсо"
    },
    "renew": {
      "one": "Обновление"
    },
    "result": {
      "one": "Результат",
      "other": "Результаты"
    },
    "show": "Смотреть",
    "show_all": "Показать все",
    "signed": "Подписано",
    "slug": "ссылка",
    "start": {
      "one": "Начинать"
    },
    "status": "Статус",
    "subscription": {
      "cancel_date": "Дата отмены",
      "uncancel": {
        "one": "Повторно активировать подписку"
      }
    },
    "subtotal": "Итого",
    "system": {
      "dashboards": {
        "index": {
          "create_checkin_confirm": "Подтвердить чек-ин этого ученика сегодня?",
          "enable_credit": "Включить функцию кредитов",
          "enrollments_not_found": "Активных или просроченных регистраций не обнаружено.",
          "new_enrollment": "Новая регистрация",
          "new_subscription": "Новая подписок",
          "new_subscription_disabled_tooltip": "У студента уже есть активная или просроченная подписка.",
          "register_as_student": "Зарегистрироваться как студент",
          "subscriptions_not_found": "Активных или просроченных подписок не обнаружено."
        }
      },
      "evaluation_options": {
        "rating": "Оценка %{name}",
        "rating_scored": "Оценка %{name}: %{score}"
      },
      "subscriptions": {
        "form": {
          "generate_first_invoice": "Сгенерировать первый счет ?",
          "generate_first_invoice_credit_card": "Выполнить первый платеж по карте ?"
        }
      }
    },
    "time": {
      "one": "Время"
    },
    "today": "Сегодня",
    "total": "Всего",
    "transfer": {
      "verb": "Передача"
    },
    "user": {
      "not_student": "не является студентом в этом филиале."
    },
    "user_unit_access": {
      "denied": "Ученик должен разрешить доступ к своим личным данным для выполнения этого действия. Запросить доступ сейчас?",
      "request": {
        "confirm": "Отправить уведомление ученику с запросом доступа к личным данным?",
        "verb": "Запросить доступ"
      }
    },
    "wait": "Ожидайте...",
    "whatsapp": "WhatsApp"
  }
}